import theme from '../themes/default';
export default {
	qrc: {
		background: 'white',
		'box-shadow': '0 4px 17px 0 rgb(160 156 156 / 36%)',
		'margin-top': '15px',
		'padding-top': '15px',
		'padding-left': '20px',
		'margin-bottom': '20px',
		'padding-right': '20px',
		'padding-bottom': '15px',
		'border-top-left-radius': '15px',
		'border-top-right-radius': '15px',
		'border-bottom-left-radius': '15px',
		'border-bottom-right-radius': '15px',
		'& > canvas': {
			'padding-left': 0,
			'padding-right': 0,
			'margin-left': 'auto',
			'margin-right': 'auto',
			display: 'block'
		}
	},
	scanText: {
		'text-align': 'center'
	},
	confirmPayment: {
		'text-align': 'center',
		'& > span': {
			border: 'solid 1px #614D4A',
			display: 'inline-block',
			padding: '3px',
			'border-radius': '5px'
		}
	}
};



// WEBPACK FOOTER //
// ./src/assets/styles/components/QrcPayment.js